import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import isEmpty from 'lodash/isEmpty';

import BlockComponent from './BlockComponent';
import blockDefinition from './definitions/text.json';

const propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    quote: PropTypes.string,
    description: PropTypes.string,
    url: PropTypes.string,
    link: PropTypes.string,
    coloredTitle: PropTypes.bool,
    coloredSubtitle: PropTypes.bool,
    coloredText: PropTypes.bool,
    invertTitle: PropTypes.bool,
    pageTitle: PropTypes.bool,
    titleFont: PropTypes.string,
};

const defaultProps = {
    title: null,
    subtitle: null,
    quote: null,
    description: null,
    url: null,
    link: null,
    coloredTitle: true,
    coloredSubtitle: true,
    coloredQuote: true,
    coloredText: false,
    invertTitle: false,
    pageTitle: false,
    titleFont: 'normal',
};

class TextBlock extends BlockComponent {

    render() {
        const {
            title,
            subtitle,
            quote,
            description,
            url,
            link,
            titleFont,
            coloredText,
            coloredTitle,
            coloredSubtitle,
            coloredQuote,
            pageTitle,
            invertTitle,
        } = this.props;

        const realTitle = invertTitle ? subtitle : title;
        const realSubtitle = invertTitle ? title : subtitle;

        if (
            isEmpty(realTitle) &&
            isEmpty(realSubtitle) &&
            isEmpty(quote) &&
            isEmpty(description) &&
            isEmpty(url)
        ) {
            return null;
        }

        const className = classNames({
            'block-text': true,
        });

        const titleClassName = classNames({
            title: true,
            'page-title': pageTitle,
            colored: coloredTitle === null || coloredTitle,
            [`font-${titleFont}`]: !isEmpty(titleFont),
            'with-subtitle': !isEmpty(realSubtitle) && !invertTitle,
        });

        const subtitleClassName = classNames({
            subtitle: true,
            colored: coloredSubtitle === null || coloredSubtitle,
            'with-title': !isEmpty(realTitle) && invertTitle,
        });

        const quoteClassName = classNames({
            quote: true,
            colored: coloredQuote === null || coloredQuote,
        });

        const textClassName = classNames({
            text: true,
            colored: coloredText,
        });

        return (
            <div className={className}>
                { !isEmpty(realSubtitle) && invertTitle ? (
                    <h4 className={subtitleClassName}>{`${realSubtitle}`}</h4>
                ) : null }
                { !isEmpty(realTitle) ? (
                    <h2 className={titleClassName}>{realTitle}</h2>
                ) : null }
                { !isEmpty(realSubtitle) && !invertTitle ? (
                    <h4 className={subtitleClassName}>{`${realSubtitle}`}</h4>
                ) : null }
                { !isEmpty(quote) ? (
                    <h5 className={quoteClassName}>{ quote }</h5>
                ) : null }
                { !isEmpty(description) ? (
                    <div className={textClassName}>
                        <ReactMarkdown source={description} />
                    </div>
                ) : null }
                { !isEmpty(url) ? (
                    <div className="link"><a href={url} target="_blank">{ link }&nbsp;&gt;</a></div>
                ) : null }
            </div>
        );
    }
}

TextBlock.propTypes = propTypes;
TextBlock.defaultProps = defaultProps;
TextBlock.blockDefinition = blockDefinition;

export default TextBlock;



// WEBPACK FOOTER //
// ./components/blocks/Text.jsx